import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import AdminSessionGuard from "./components/AdminSessionGuard";
import InstallPWA from "./components/InstallPWA";
import Home from "./pages/Home";

const Login = lazy(() => import("./pages/Login"));
const PanelApp = lazy(() => import("./PanelApp"));

const RouteFallback = () => (
  <div className="min-h-[100dvh] bg-[#030617]" role="status" aria-live="polite">
    <span className="sr-only">Loading</span>
  </div>
);

function App() {
  return (
    <>
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<PanelApp />} />
        </Routes>
      </Suspense>
      <AdminSessionGuard />
      <ToastContainer theme="dark" />
      <InstallPWA />
    </>
  );
}

export default App;
